mutation deleteSavedContent($input: DeleteSavedContentInput!) {
  deletedSavedContent: deleteSavedContent(input: $input)
}
